import { ApproveSecurityRequest } from 'src/app/web-api-client';
import { AccordionSecurityReview } from '../../models/edit-tax-result-approval/accordion-security-review';

export function mapAccordionToApproveRequest(
  accordionSecuritiesReview: AccordionSecurityReview[]
): ApproveSecurityRequest[] {
  return accordionSecuritiesReview.map(
    (accordionItem: AccordionSecurityReview) =>
      new ApproveSecurityRequest({
        securityId: accordionItem.security.securityId,
      })
  );
}
